import { createElement, memo, useState, useEffect } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Image from '@hfe/max-image';
import Button from '@hfe/max-button';
import ScrollView from '@hfe/max-scrollview';
import LinearGradient from '@hfe/max-linear-gradient';
import TopView from '@max/leez-top-view';
import ModalBaseContainer from '@max/leez-modal-base-container';
import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
import { useRequest } from '../../hooks/useRequest';
import { API_PATH } from '../../types/shared';
import { getRequestBaseParams } from '../../utils/request';
import './index.scss';
const DEFAULT_HEADER_IMAGE = 'https://p0.meituan.net/ingee/2db81e9b679ff0c79ab50ccc05e004e614622.png';
const SUB_TITLE = '本期活动获奖用户';
const CONFIRM_BTN_TEXT = '我知道了';
// 用户名脱敏：前2后2，中间替换为 **
function maskUserName(name) {
    if (!name)
        return '';
    if (name.length > 4) {
        return name.slice(0, 2) + '**' + name.slice(-2);
    }
    return name.slice(0, 2) + '**';
}
function WinnerListModal(props) {
    const { visible, activityId, headerImage, onClose } = props;
    const ctx = useMonitorEngineContext();
    const commonParams = ctx._runtimeInfo?.commonParams;
    const { request } = useRequest(API_PATH.FREE_ORDER_CARD_LEADERBOARD);
    // R004：中奖名单，visible 变为 true 时请求 3.12 接口
    const [winnerList, setWinnerList] = useState([]);
    useEffect(() => {
        if (!visible)
            return;
        async function fetchWinnerList() {
            try {
                const feCommonParams = await getRequestBaseParams(commonParams);
                const res = await request({
                    activityId,
                    ...feCommonParams
                });
                setWinnerList(res?.leaderboardItems ?? []);
            }
            catch (error) {
                ctx._raptorReport.monitorReportLog?.('fetchWinnerList', error, {
                    level: 'error',
                    category: 'ajaxError'
                });
            }
        }
        fetchWinnerList();
    }, [visible]);
    return <TopView>
      <ModalBaseContainer visible={visible} type="fade" onMaskPress={onClose} maskStyle={{
        opacity: 0.8
    }} maskAnimationIn={{
        opacity: [0, 0.8],
        duration: 300
    }} 
    // 设置蒙层出场动画结束后的透明度为 0
    maskAnimationOut={{
        opacity: [0.8, 0],
        duration: 300
    }}>
        <View className="winner-list-modal__wrapper">
          <View className="winner-list-modal__content-wrapper">
            
            <Image className="winner-list-modal__header-image" source={{
        uri: headerImage ?? DEFAULT_HEADER_IMAGE
    }}/>
            
            <Text className="winner-list-modal__sub-title">{SUB_TITLE}</Text>
            
            <View className="winner-list-modal__list-wrapper">
              <ScrollView showsVerticalScrollIndicator={false}>
                <View className="winner-list-modal__scroll-content">
                  {winnerList.map((item, index) => <View key={index} className="winner-list-modal__item">
                      <View className="winner-list-modal__item-divider"/>
                      <View className="winner-list-modal__item-row">
                        <Text className="winner-list-modal__item-index">{index + 1}</Text>
                        <Text className="winner-list-modal__item-name">{maskUserName(item.userName ?? '')}</Text>
                        <Text className="winner-list-modal__item-tag">已得免单</Text>
                      </View>
                    </View>)}
                  <View className="winner-list-modal__scroll-footer"/>
                </View>
              </ScrollView>
              <LinearGradient className="winner-list-modal__bottom-gradient" colors={['#ffffff00', '#ffffffff']} start={{
        x: 0,
        y: 0
    }} end={{
        x: 0,
        y: 1
    }}/>
            </View>
            
            <Button className="winner-list-modal__confirm-btn" onPress={() => {
        onClose();
    }}>
              <Text className="winner-list-modal__confirm-btn-text">{CONFIRM_BTN_TEXT}</Text>
            </Button>
          </View>
          
          <Button className="cfe-five-city-close-button" onPress={() => {
        onClose();
    }}>
            <Image className="cfe-five-city-close-button-img" source={{
        uri: 'https://p0.meituan.net/ingee/dacb6cc62b5d35e0e749fc7a73bbe7821798.png'
    }}/>
          </Button>
        </View>
      </ModalBaseContainer>
    </TopView>;
}
export default memo(WinnerListModal);
